import { RouteName as CommerceRouteName } from '@amp-ui-commerce/commercekit';

// These paths are not intended to be a 1:1 match to the `RoutePath`s in CommerceKit
export enum CommerceRoute {
    authenticate = '/authenticate',
    gdpr = '/account/privacy',
    logout = '/logout',
    settings = '/account/settings',
    subscribe = '/subscribe',
    billing = '/account/billing',

    // The following routes were taken from src/jet/intents/commerce/types
    // and cross-referenced with routes supported in CommerceKit here: https://github.pie.apple.com/amp-ui/commerce-app/blob/dd253d2469a28cd9f07175e2d059006122f41f87/packages/commercekit/src/embedding/routes.ts#L33-L61
    // less any already routes already defined in our app (above).
    // These are added here so CommerceKit knows which route to open given a known path
    ageVerification = '/account/verification',
    carrierLinking = '/account/carrier-linking',
    contentRestricted = '/content-restricted',
    createAccount = '/account/create',
    editBilling = '/account/edit-billing',
    koreaAgeVerification = '/age-verification/landing',
    planCancel = '/plan/cancel',
    planReactivate = '/plan/reactivate',
    planSubscribe = '/plan/subscribe',
    redeem = '/redeem',
    subscribeCarrier = '/subscribe/carrier',
    terms = '/terms-agreement',
    subscribeStudent = '/subscribe/student',
    planSelection = '/subscribe/plan-selection',
    studentSubscriptionOffers = '/subscribe/student-subscribe',
    studentVerified = '/subscribe/student/verified',
    studentReverification = '/subscribe/student/reverification',
}

// These routes should open in an embedded layout instead of in a modal
// See CommerceKit config here (where `expectsFullscreenLayout: true`):
// https://github.pie.apple.com/amp-ui/commerce-app/blob/1a2876b3522a81ffc7fe760bda9a9b64a40cd853/packages/commercekit/src/embedding/routes.ts#L102
export const EMBEDDED_ROUTES = [CommerceRoute.settings];

export const COMMERCE_ROUTE_MAP: { [key in CommerceRoute]: string } = {
    [CommerceRoute.ageVerification]: CommerceRouteName.AgeVerification,
    [CommerceRoute.authenticate]: CommerceRouteName.Authenticate,
    [CommerceRoute.billing]: CommerceRouteName.Billing,
    [CommerceRoute.carrierLinking]: CommerceRouteName.CarrierLinking,
    [CommerceRoute.contentRestricted]: CommerceRouteName.ContentRestricted,
    [CommerceRoute.createAccount]: CommerceRouteName.CreateAccount,
    [CommerceRoute.editBilling]: CommerceRouteName.EditBilling,
    [CommerceRoute.gdpr]: CommerceRouteName.Gdpr,
    [CommerceRoute.koreaAgeVerification]:
        CommerceRouteName.KoreaAgeVerification,
    [CommerceRoute.logout]: CommerceRouteName.Logout,
    [CommerceRoute.planCancel]: CommerceRouteName.PlanCancel,
    [CommerceRoute.planReactivate]: CommerceRouteName.PlanReactivate,
    [CommerceRoute.planSubscribe]: CommerceRouteName.PlanSubscribe,
    [CommerceRoute.redeem]: CommerceRouteName.Redeem,
    [CommerceRoute.settings]: CommerceRouteName.Settings,
    [CommerceRoute.subscribe]: CommerceRouteName.Subscribe,
    [CommerceRoute.subscribeStudent]: CommerceRouteName.Subscribe,
    [CommerceRoute.subscribeCarrier]: CommerceRouteName.SubscribeCarrier,
    [CommerceRoute.terms]: CommerceRouteName.Terms,
};

export enum COMMERCE_RECEIVE_EVENTS {
    DID_SIGN_IN = 'signedin',
    DID_CLOSE = 'closed',
    DID_GDPR_ACKNOWLEDGE = 'gdpracknowledged',
}
